// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"565":"67425b37","2677":"31b4a395","7770":"abfe5b28","7792":"cf415eac","7850":"02990f7e"}[chunkId] + ".chunk.css";
};